export interface AiScrubBatchEmptyError {
  kind: 'ai-scrub-batch-empty';
}

export const isAiScrubBatchEmptyError = (value: unknown): value is AiScrubBatchEmptyError =>
  typeof value === 'object'
  && value !== null
  && (value as AiScrubBatchEmptyError).kind === 'ai-scrub-batch-empty';
